import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { Constants } from '../../shared/config/constants.config';
import { UsersService } from '../../shared/services/users.service';
var PricingService = /** @class */ (function () {
    function PricingService(constants, usersService, httpClient) {
        this.constants = constants;
        this.usersService = usersService;
        this.httpClient = httpClient;
        this.userSubscription = null;
        this.isMasterUser = null;
        this.permissions = {
            'AUTO_FILL_DIARY_RECIEPS': 'AUTO_FILL_DIARY_RECIEPS',
            'EXTERNAL_MEALS': 'EXTERNAL_MEALS',
            'SHOPPING_LIST': 'SHOPPING_LIST',
            'DAY_TRAINING': 'DAY_TRAINING',
            'EXTERNAL_LOAD': 'EXTERNAL_LOAD',
            'COPY_DIARY_RECIPES': 'COPY_DIARY_RECIPES',
            'COPY_DIARY_SINGLE_RECIPE': 'COPY_DIARY_SINGLE_RECIPE',
            'DELETE_DIARY_RECIPES': 'DELETE_DIARY_RECIPES',
        };
        this.freePlanPermissions = [];
        this.lightPlanPermissions = [
            this.permissions['EXTERNAL_MEALS'],
            this.permissions['SHOPPING_LIST']
        ];
        this.standartPlanPermissions = [
            this.permissions['AUTO_FILL_DIARY_RECIEPS'],
            this.permissions['EXTERNAL_MEALS'],
            this.permissions['SHOPPING_LIST'],
            this.permissions['DAY_TRAINING'],
            this.permissions['EXTERNAL_LOAD'],
            this.permissions['COPY_DIARY_RECIPES'],
            this.permissions['COPY_DIARY_SINGLE_RECIPE'],
            this.permissions['DELETE_DIARY_RECIPES']
        ];
    }
    PricingService.prototype.getPricings = function () {
        return this.httpClient.get(this.constants.apiURL() + "/pricing/");
    };
    PricingService.prototype.getPaymentMethods = function () {
        return this.httpClient.get(this.constants.apiURL() + "/payment/methods/");
    };
    PricingService.prototype.createSubscription = function (createSubscriptionDTO) {
        return this.httpClient.post(this.constants.apiURL() + "/subscription/", createSubscriptionDTO);
    };
    PricingService.prototype.createYettelSubscription = function () {
        return this.httpClient.post(this.constants.apiURL() + "/subscription/yettel/", {});
    };
    PricingService.prototype.getYettelSubscription = function () {
        return this.httpClient.get(this.constants.apiURL() + "/subscription/yettel/");
    };
    PricingService.prototype.braintreeGenerateClientToken = function () {
        return this.httpClient.get(this.constants.apiURL() + "/braintree/client-token/");
    };
    PricingService.prototype.createSubscriptionAddonTransaction = function (createSubscriptionRequestDTO) {
        return this.httpClient.post(this.constants.apiURL() + "/subscription/addon/" + createSubscriptionRequestDTO.influencer_id + "/buy/transaction/", createSubscriptionRequestDTO);
    };
    PricingService.prototype.getDiscount = function (discountRequestDTO) {
        return this.httpClient.post(this.constants.apiURL() + "/pricing/discount/", discountRequestDTO);
    };
    PricingService.prototype.isFreePlan = function () {
        var _this = this;
        return new Observable(function (observer) {
            if (_this.userSubscription === null) {
                forkJoin([
                    _this.usersService.getMasterUserProfile(),
                    _this.usersService.getUserSubscription()
                ]).subscribe(function (_a) {
                    var masterProfile = _a[0], subscription = _a[1];
                    _this.userSubscription = subscription;
                    _this.isMasterUser = masterProfile.is_master_profile === true;
                    if (_this.isMasterUser) {
                        observer.next(false);
                        observer.complete();
                    }
                    if (_this.userSubscription === null) {
                        observer.next(true);
                        observer.complete();
                    }
                    if (_this.userSubscription.pricing_plan.id === 4) {
                        observer.next(true);
                        observer.complete();
                    }
                    if (_this.userSubscription.pricing_plan.title === 'Безплатен' || _this.userSubscription.pricing_plan.title === 'Free') {
                        observer.next(true);
                        observer.complete();
                    }
                    observer.next(false);
                    observer.complete();
                });
            }
            else {
                if (_this.isMasterUser) {
                    observer.next(false);
                    observer.complete();
                }
                if (_this.userSubscription === null) {
                    observer.next(true);
                    observer.complete();
                }
                if (_this.userSubscription.pricing_plan.id === 4) {
                    observer.next(true);
                    observer.complete();
                }
                if (_this.userSubscription.pricing_plan.title === 'Безплатен' || _this.userSubscription.pricing_plan.title === 'Free') {
                    observer.next(true);
                    observer.complete();
                }
                observer.next(false);
                observer.complete();
            }
        });
    };
    PricingService.prototype.isPermissionAllowed = function (permission) {
        return new Observable(function (observer) {
            // override and return that always allowed
            observer.next(true);
            observer.complete();
            // if (this.userSubscription === null) {
            //     this.usersService.getUserSubscription().subscribe(subscription => {
            //         this.userSubscription = subscription;
            //
            //         // free plan
            //         if (this.userSubscription === null || this.userSubscription.pricing_plan.id === 4 || this.userSubscription.pricing_plan.title === 'Безплатен' || this.userSubscription.pricing_plan.title === 'Free') {
            //             if (this.freePlanPermissions.includes(permission)) {
            //                 observer.next(true);
            //             } else {
            //                 observer.next(false);
            //             }
            //
            //             observer.complete();
            //         }
            //
            //         // light plan
            //         if (this.userSubscription !== null && this.userSubscription.pricing_plan.id === 9) {
            //             if (this.lightPlanPermissions.includes(permission)) {
            //                 observer.next(true);
            //             } else {
            //                 observer.next(false);
            //             }
            //
            //             observer.complete();
            //         }
            //
            //         // standart plan
            //         if (this.userSubscription !== null && this.userSubscription.pricing_plan.id === 7) {
            //             if (this.standartPlanPermissions.includes(permission)) {
            //                 observer.next(true);
            //             } else {
            //                 observer.next(false);
            //             }
            //
            //             observer.complete();
            //         }
            //
            //         observer.next(false);
            //         observer.complete();
            //     });
            //
            // } else {
            //     // free plan
            //     if (this.userSubscription === null || this.userSubscription.pricing_plan.id === 4 || this.userSubscription.pricing_plan.title === 'Безплатен' || this.userSubscription.pricing_plan.title === 'Free') {
            //         if (this.freePlanPermissions.includes(permission)) {
            //             observer.next(true);
            //         } else {
            //             observer.next(false);
            //         }
            //
            //         observer.complete();
            //     }
            //
            //     // light plan
            //     if (this.userSubscription !== null && this.userSubscription.pricing_plan.id === 9) {
            //         if (this.lightPlanPermissions.includes(permission)) {
            //             observer.next(true);
            //         } else {
            //             observer.next(false);
            //         }
            //
            //         observer.complete();
            //     }
            //
            //     // standart plan
            //     if (this.userSubscription !== null && this.userSubscription.pricing_plan.id === 7) {
            //         if (this.standartPlanPermissions.includes(permission)) {
            //             observer.next(true);
            //         } else {
            //             observer.next(false);
            //         }
            //
            //         observer.complete();
            //     }
            //
            //     observer.next(false);
            //     observer.complete();
            // }
        });
    };
    return PricingService;
}());
export { PricingService };
